import { a as AbstractClientWallet } from '../../../../dist/base-a684cdcb.browser.esm.js';
import { w as walletIds } from '../../../../dist/walletIds-d49f47a5.browser.esm.js';
import '../../abstract/dist/thirdweb-dev-wallets-evm-wallets-abstract.browser.esm.js';
import 'ethers';
import 'eventemitter3';
import '@thirdweb-dev/sdk';
import '@thirdweb-dev/chains';

class PaperWallet extends AbstractClientWallet {
  static id = walletIds.paper;
  static meta = {
    name: "Paper Wallet",
    iconURL: "ipfs://QmNrLXtPoFrh4yjZbXui39zUMozS1oetpgU8dvZhFAxfRa/paper-logo-icon.svg"
  };
  get walletName() {
    return "Paper Wallet";
  }
  constructor(options) {
    super(PaperWallet.id, {
      ...options
    });
    this.paperClientId = options.paperClientId;
    this.chain = options.chain;
  }
  async getConnector() {
    if (!this.connector) {
      const {
        PaperWalletConnector
      } = await import('../../../connectors/paper/dist/thirdweb-dev-wallets-evm-connectors-paper.browser.esm.js');
      this.connector = new PaperWalletConnector({
        clientId: this.paperClientId,
        chain: this.chain,
        chains: this.chains,
        advancedOptions: {
          recoveryShareManagement: this.options?.advancedOptions?.recoveryShareManagement
        },
        styles: this.options?.styles
      });
    }
    return this.connector;
  }
  async getEmail() {
    const connector = await this.getConnector();
    return connector.getEmail();
  }
}

export { PaperWallet };
